import React, { Component } from "react";
import { BaseComponent, required, trim, email } from "BaseComponent";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import { isEmpty } from "BaseFunctions";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";
import { confirmAlert } from "react-confirm-alert";
import moment from "moment";
import {
  APP_API_KEY,
  INSTANCE_URL,
  DATE_FORMAT_WITH_TIME_WITH_SECOND,
} from "Constants";

import {
  fetchTemplatesWizardStep,
  saveTemplatesWizardData,
  showConfirmModal,
  addWebsiteModuleData,
  deployWebsite,
  fetchSiteDetails,
  makeFresh,
  resetSiteDetails,
  redeployFunction,
} from "../../actions";

class Confirm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showModal: false,
      showDeployLoadingMsg: false,
      showDeployLoadedMsg: false,
    };
  }

  reset = () => {
    this.props.saveTemplatesWizardData({});
  };

  onSubmitForm = (values) => {
    this.setState({ loading: true });
    this.setState({ showDeployLoadingMsg: true });

    var { TemplatesWizardData, session, eventcode } = this.props;

    let data = TemplatesWizardData;
    data.resource.publish.purchasecredentials = values;
    this.props.saveTemplatesWizardData(data);

    let publish =
      TemplatesWizardData &&
      TemplatesWizardData.resource &&
      TemplatesWizardData.resource.publish &&
      !_.isEmpty(TemplatesWizardData.resource.publish)
        ? TemplatesWizardData.resource.publish
        : undefined;

    setTimeout(() => {
      if (publish.option === "free") {
        let resource = [
          {
            eventid: session.eventid,
            templateid: TemplatesWizardData.resource.theme.selectedtemplate.id,
            adminemail:
              TemplatesWizardData.resource.publish.purchasecredentials
                .adminemail,
            website_subdomain:
              TemplatesWizardData.resource.url.option === "useeventify"
                ? TemplatesWizardData.resource.url.eventifydomainname
                : session.eventname.replace(/[^a-zA-Z0-9]/g, "").toLowerCase(),
            domain_name:
              TemplatesWizardData.resource.url.option === "connectown"
                ? TemplatesWizardData.resource.url.userdomainname
                : null,
            is_domain_verified: 0, //As of now, domain verification not implemented
            plan_purchase:
              TemplatesWizardData.resource.publish.option === "free"
                ? "free"
                : TemplatesWizardData.resource.publish.selectedplan.value,
            deploydate: moment
              .utc(moment().add(1, "minutes"))
              .format(DATE_FORMAT_WITH_TIME_WITH_SECOND),
          },
        ];

        let deployParams = {
          eventcode: eventcode,
          template:
            TemplatesWizardData.resource.theme.selectedtemplate.modulepath,
          subdomain:
            TemplatesWizardData.resource.url.option === "useeventify"
              ? TemplatesWizardData.resource.url.eventifydomainname
              : session.eventname.replace(/[^a-zA-Z0-9]/g, "").toLowerCase(),
          metakeywords: TemplatesWizardData.resource.overview.metakeywords
            ? TemplatesWizardData.resource.overview.metakeywords
            : "",
          metadescription: TemplatesWizardData.resource.overview.metadescription
            ? TemplatesWizardData.resource.overview.metadescription
            : "",
          adminemail:
            TemplatesWizardData.resource.publish.purchasecredentials.adminemail,
          adminpass:
            TemplatesWizardData.resource.publish.purchasecredentials.adminpass,
        };

        let { redeploy } = this.props;

        if (redeploy && !_.isEmpty(redeploy) && redeploy.redeploy) {
          this.props.makeFresh(this.props.session, (resMakeFresh) => {
            if (resMakeFresh.success) {
              this.props.addWebsiteModuleData(session, resource, (res) => {
                if (res.success) {
                  this.props.deployWebsite(
                    session,
                    deployParams,
                    (resDeploy) => {
                      if (resDeploy.success) {
                        this.setState({ showDeployLoadingMsg: false });
                        this.setState({ showDeployLoadedMsg: true });
                        this.setState({ loading: false });
                        this.props.showSuccess(
                          "Website deployed successfully!"
                        );
                        this.props.fetchSiteDetails(this.props.session);
                        this.close();
                        setTimeout(() => {
                          this.redirectToDashboard();
                          this.reset();
                        }, 100);

                        // confirmAlert({
                        //     title: "Website Deployed Successfully!",
                        //     message: "Click Ok to redirect to Dashboard.",
                        //     confirmLabel: "Ok",
                        //     cancelLabel: "Cancel",
                        //     onConfirm: () => {
                        //         setTimeout(() => {
                        //             this.close();
                        //             this.reset();
                        //             this.props.fetchSiteDetails(this.props.session);
                        //             this.redirectToDashboard();
                        //         }, 100);
                        //     },
                        //     onCancel: () => {

                        //     }
                        // });

                        this.props.resetSiteDetails();
                        this.props.redeployFunction({}); // {redeploy: false, from: null, data: {}}
                      } else {
                        this.setState({ loading: false });
                        this.props.showError(COMMON_FAIL_MESSAGE);
                      }
                    }
                  );
                } else {
                  this.setState({ loading: false });
                  this.props.showError(COMMON_FAIL_MESSAGE);
                }
              });
            }
          });
        } else {
          this.props.addWebsiteModuleData(session, resource, (res) => {
            if (res.success) {
              this.props.deployWebsite(session, deployParams, (resDeploy) => {
                if (resDeploy.success) {
                  this.setState({ showDeployLoadingMsg: false });
                  this.setState({ showDeployLoadedMsg: true });
                  this.setState({ loading: false });
                  this.props.showSuccess("Website deployed successfully!");
                  this.props.fetchSiteDetails(this.props.session);
                  this.close();
                  setTimeout(() => {
                    this.redirectToDashboard();
                    this.reset();
                  }, 100);

                  // confirmAlert({
                  //     title: "Website Deployed Successfully!",
                  //     message: "Click Ok to redirect to Dashboard.",
                  //     confirmLabel: "Ok",
                  //     cancelLabel: "Cancel",
                  //     onConfirm: () => {
                  //         setTimeout(() => {
                  //             this.close();
                  //             this.reset();
                  //             this.props.fetchSiteDetails(this.props.session);
                  //             this.redirectToDashboard();
                  //         }, 100);
                  //     },
                  //     onCancel: () => {

                  //     }
                  // });
                } else {
                  console.log("FAILED IN DEPLOYMENT");
                  this.setState({ loading: false });
                  this.props.showError(COMMON_FAIL_MESSAGE);
                }
              });
            } else {
              console.log("FAILED TO INSERT INTO DB");
              this.setState({ loading: false });
              this.props.showError(COMMON_FAIL_MESSAGE);
            }
          });
        }
      } else {
        confirmAlert({
          title: "Payment",
          message: "Sorry! Payment method is unavailable right now.",
          confirmLabel: "",
          cancelLabel: "Close",
          buttons: [
            {
              label: "",
              onClick: () => {
                this.setState({ loading: false });
                this.close();
              },
            },
            {
              label: LocaleStrings.button_close,
              onClick: () => {
                this.setState({ loading: false });
                this.close();
              },
            },
          ],
        });
      }
    }, 1);
  };

  open() {
    this.props.showConfirmModal({ showModal: true });
  }

  redirectToDashboard = () => {
    var path = "dashboard";
    this.props.history.push(`/dashboard/website/${path}`);
  };

  close() {
    // if(this.state.showDeployLoadedMsg){
    //     this.reset();
    //     this.redirectToDashboard();
    // }

    this.props.showConfirmModal({ showModal: false });
  }

  renderFieldText(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0";
    var noteClasses = "col-sm-12 col-sm-offset-0 text-muted-custom";

    return (
      <div className={divClassName}>
        <label className={labelClasses} style={{ color: "#767988" }}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>

        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
            max={field.max ? field.max : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>

        <div className={noteClasses}>
          <p>{field.note}</p>
        </div>
      </div>
    );
  }

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      editMode,
      initialValues,
      TemplatesWizardStep,
      TemplatesWizardData,
      confirmModal,
    } = this.props;

    let publish =
      TemplatesWizardData &&
      TemplatesWizardData.resource &&
      TemplatesWizardData.resource.publish &&
      !_.isEmpty(TemplatesWizardData.resource.publish)
        ? TemplatesWizardData.resource.publish
        : undefined;

    return (
      <div>
        <Modal
          className="modal-container"
          show={confirmModal.showModal === true ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header>
            <div className="import-modal-title">Confirm and Purchase</div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={(e) => this.close()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div style={{ width: "100%", marginBottom: 10 }}>
              <form onSubmit={handleSubmit(this.onSubmitForm)}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      {publish.option === "free" ? (
                        <label
                          className="control-label-top col-sm-12"
                          style={{ color: "#767988" }}
                        >
                          <div>Free</div>
                        </label>
                      ) : (
                        <label
                          className="control-label-top col-sm-12"
                          style={{ color: "#767988" }}
                        >
                          <div className="mb-10">
                            {" "}
                            {publish.selectedplan.name}{" "}
                          </div>
                          {_.map(publish.selectedplan.options, (opt) => {
                            return <div className="ml-40">{"- " + opt}</div>;
                          })}
                          <div className="ml-40 mt-20">
                            {" "}
                            {publish.selectedplan.description}{" "}
                          </div>
                        </label>
                      )}

                      <div className="col-md-12">
                        <Button
                          className="btn-custom-blue mt-10 mb-40 ml-40"
                          disabled={false}
                          onClick={(e) => this.close()}
                        >
                          Change Plan
                        </Button>
                      </div>
                    </div>

                    <Field
                      name="adminemail"
                      label={"Admin Email ID"}
                      placeholder={"Enter email id"}
                      type="email"
                      mandatory="true"
                      component={this.renderFieldText}
                      validate={[required, email]}
                      normalize={trim}
                    />

                    <Field
                      name="adminpass"
                      label={"Admin Password"}
                      placeholder={"Enter password"}
                      type="password"
                      mandatory="true"
                      component={this.renderFieldText}
                      validate={required}
                    />

                    <div className="col-md-12 text-center">
                      <Button
                        className="btn-custom-blue mt-70 mb-10"
                        loading={this.state.loading}
                        disabled={pristine || invalid || submitting}
                        type="submit"
                      >
                        {publish.option === "free" ? "Deploy" : "Make Payment"}
                      </Button>
                    </div>

                    {this.state.showDeployLoadingMsg ? (
                      <div className="col-md-12 text-center">
                        Deplyoment in progress... It will take atmost 1 minute.
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.showDeployLoadedMsg ? (
                      <div className="col-md-12 text-center">
                        Congrats! Website Deployed.
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-custom-white"
              onClick={(e) => this.close()}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  return errors;
}

function mapStateToProps(state) {
  var initVals = null;
  var toEdit = false;

  // if (state.connectDomainData && !_.isEmpty(state.connectDomainData)) {
  //     initVals = state.connectDomainData.values;
  //     toEdit = true;
  // }

  return {
    session: state.session,
    initialValues: initVals,
    editMode: toEdit,
    TemplatesWizardStep: state.TemplatesWizardStep,
    TemplatesWizardData: state.TemplatesWizardData,
    confirmModal: state.confirmModal,
    eventcode: state.eventcode,

    siteDetails: state.siteDetails,
    redeploy: state.redeploy,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchTemplatesWizardStep,
  saveTemplatesWizardData,
  showConfirmModal,
  addWebsiteModuleData,
  deployWebsite,
  fetchSiteDetails,
  makeFresh,
  resetSiteDetails,
  redeployFunction,
})(
  reduxForm({
    validate,
    form: "TemplatesWizardConfirmForm",
    enableReinitialize: true,
    // keepDirtyOnReinitialize: true
  })(Confirm)
);
